var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link-modified',{staticClass:"base-btn base-btn--blue",attrs:{"to":{name: 'vacancies'}}},[_c('span',{staticClass:"base-btn__text"},[_vm._v(_vm._s(_vm.text))]),_c('BaseSvg',{attrs:{"name":"ico-arrow-light"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }